import MailGroups       from "../../../../domain/mail/group/MailGroups";
import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_MAIL_GROUPS = "SET_MAIL_GROUPS",
}

export interface SetMailGroupsAction extends ResKaReduxAction {
  mailGroups: MailGroups;
}

export type MailGroupsAction = SetMailGroupsAction;

export const setMailGroupsAction = (mailGroups: MailGroups): SetMailGroupsAction => ({
  type: ACTION_TYPE.SET_MAIL_GROUPS,
  mailGroups: mailGroups,
});